import $api from 'http';

export async function getGuardByEmployee() {
  return $api.get('/tabel/guard-by-employee/');
}

export async function getTopBaseOperatorByEmployee() {
  return $api.get('/tabel/topbaseoperator-by-employee/');
}

export async function getChppOperatorByEmployee() {
  return $api.get('/tabel/chppoperator-by-employee/');
}

export async function getPrivatePointOperatorByEmployee() {
  return $api.get('/tabel/privatepointoperator-by-employee/');
}
